import React, { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CompletedCardHolder } from '~/img';
import theme from '~/constants/theme';

const Completion: FC = () => {
  const { t } = useTranslation('cardholder');

  return (
    <Container className="Completed">
      <div className="Completed-Content">
        <Typography.Title className="Completed-Title">{t('cardholder.completion.welcome')}</Typography.Title>
        <Typography.Paragraph className="Completed-Paragraph">
          <p>{t('cardholder.completion.welcome.label1')}</p>
          {/* <p>{t('cardholder.completion.welcome.label2')}</p> */}
        </Typography.Paragraph>
        <CompletedCardHolder className="Completed-Img" />
      </div>
    </Container>
  );
};

const Container = styled.div`
  .Completed-Content {
    position: relative;
    .Completed-Img {
      width: 100%;
      margin-bottom: 24px;
    }
    .Completed-Paragraph {
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .Completed-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Paragraph {
        margin-left: 0;
      }
    }
  }
  .Completed-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .Completed-ContactUs {
      display: none;
    }
  }
`;

export default Completion;
